import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/common/Tabs';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SeoSetting from './components/SeoSetting';
import { SEO_ENTITY_TYPE } from '@/configs/constants';
import BannerSetting from './components/BannerSetting';

export interface ITEM_TAB {
    value: string,
    label: string
}

export default observer(function SeoToolPage() {
    const [activeTab, setActiveTab] = useState('banner_setting');
    const { t } = useTranslation();

    const handleTabChange = (tabValue: string) => {
        setActiveTab(tabValue);
    };

    const TAB_KEY = {
        BANNER_SETTING: 'banner_setting',
        SEO_SETTING: 'seo_setting'
    };
    const SEO_TOOL_TAB_TYPE: ITEM_TAB[] = [
        {
            value: TAB_KEY.BANNER_SETTING,
            label: t('words_title.seo_tab_banner_setting')
        },
        {
            value: TAB_KEY.SEO_SETTING,
            label: t('words_title.seo_tab_seo_setting')
        }
    ];

    return (
        <div>
            <Tabs value={activeTab} onValueChange={handleTabChange} className='w-full h-full flex flex-col'>
                <div className='bg-white rounded'>
                    <TabsList variant='shop' data-orientation='horizontal' className='flex w-full mt-6 h-9'>
                        {SEO_TOOL_TAB_TYPE.map((item, index) => (
                            <TabsTrigger
                                key={index}
                                variant='shop'
                                className='text-3 w-full'
                                value={item.value}
                            >
                                {item.label}
                            </TabsTrigger>
                        ))}
                    </TabsList>
                </div>

                <div>
                    {SEO_TOOL_TAB_TYPE.map((item, index) => (
                        <TabsContent
                            key={index}
                            value={item.value}
                        >
                            {item.value === TAB_KEY.BANNER_SETTING && (
                                <div>
                                    <BannerSetting />
                                </div>
                            )}
                            {item.value === TAB_KEY.SEO_SETTING && (
                                <div>
                                    <SeoSetting seoEntityType={SEO_ENTITY_TYPE.STATIC} />
                                </div>
                            )}
                        </TabsContent>
                    ))}
                </div>
            </Tabs>
        </div>
    );
});
